<template>
  <div class="home" :class="{ heroShowing: store.heroImage }">
    <nuxt-img
      class="hero"
      :src="store.heroImage"
      v-if="store.heroImage"
      width="600"
    ></nuxt-img>

    <!-- <div>
      Venue Name: {{ profile?.venue_name }}
      <br />
      Data Version: {{ store?.version }}
    </div> -->
    <div class="buy_c" v-if="store.order || store.reservation">
      <button
        type="button"
        class="cool"
        v-if="store.order"
        @click="navigateTo(store.order, { external: true })"
      >
        Order Now
      </button>
      <button
        type="button"
        class="cool"
        v-if="store.reservation"
        @click="navigateTo(store.reservation, { external: true })"
      >
        Reservation
      </button>
    </div>

    <ImageStrip v-if="!store.loading"></ImageStrip>

    <div
      class="content sun-editor-editable"
      v-if="store.homeContent"
      v-html="store.homeContent"
    ></div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  title: "Home",
  layout: "basic",
});
const store = useStore();
let tag = useCookie("tag").value;
if (tag) store.setStore(tag);

useHead({
  title: `${tag} | Home`
});

const profile = computed(() => store.profile);
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.hero {
  width: 100%;
  margin-bottom: 40px;
}

.buy_c {
  display: flex;
  justify-content: center;
  gap: 50px;
  width: 100%;
  margin: 40px;
}

.home.heroShowing .buy_c {
  position: absolute;
}

.buy_c button {
  width: 200px;
  height: 50px;
  border: none;
  font-size: 20px;
  font-weight: bold;
}

.home.heroShowing .buy_c button {
  color: white;
  background-color: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(15px);
}

/*cool button*/
button.cool {
  position: relative;
  color: #606060;
  background-color: rgba(0, 0, 0, 0.1);
  text-transform: uppercase;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.home.heroShowing button.cool:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
button.cool:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

button.cool:active {
  transform: scale(0.99);
}

button.cool:before,
button.cool:after {
  content: "";
  position: absolute;
  transition: all 500ms cubic-bezier(0.77, 0, 0.175, 1);
  z-index: 1;
}

.home.heroShowing button.cool:before {
  border: 1px solid white;
  border-top: 0;
  border-bottom: 0;
}
button.cool:before {
  width: 100%;
  height: 0;
  left: -1px;
  top: -10%;
  bottom: 0;
  border: 1px solid #909090;
  border-top: 0;
  border-bottom: 0;
}
.home.heroShowing button.cool:after {
  border: 1px solid white;
  border-left: 0;
  border-right: 0;
}
button.cool:after {
  height: 100%;
  top: -1px;
  left: -5%;
  width: 0;
  border: 1px solid #909090;
  border-left: 0;
  border-right: 0;
}

button.cool:hover:before {
  height: 120%;
  transition-delay: 0s;
}

button.cool:hover:after {
  width: 110%;
  transition-delay: 0.35s;
}

button.cool:active:before {
  transition: all 50ms cubic-bezier(0.77, 0, 0.175, 1);
  transition-delay: 0ms;
  transform: skewX(1deg);
}
button.cool:active:after {
  transition: all 50ms cubic-bezier(0.77, 0, 0.175, 1);
  transition-delay: 0ms;
  transform: skewY(1deg);
}
</style>
```
